export default {
  Timeline: 'Timeline',
};
